import { CommonLayoutComponent } from "./features/layouts/common-layout.component";
import { Routes } from "@angular/router";
import { environment } from "../environments/environment";
import { requireCustomerLogin } from "./guards/require-login.guard";
import { redesignRedirectGuard } from "./guards/redesign-redirect.guard";

export const routes: Routes = [
  {
    path: "",
    component: CommonLayoutComponent,
    children: [
      {
        path: "login",
        children: [
          {
            path: "",
            canActivate: [redesignRedirectGuard],
            loadComponent: () => import("./pages/login/login.component").then((m) => m.LoginComponent),
          },
          {
            path: "checkout/:checkoutId",
            canActivate: [redesignRedirectGuard],
            loadComponent: () => import("./pages/login/login.component").then((m) => m.LoginComponent),
          },
        ],
      },
      {
        path: "",
        pathMatch: "full",
        redirectTo: "start",
      },
      {
        path: "start",
        canActivate: [redesignRedirectGuard],
        loadComponent: () => import("./pages/start/start.component").then((m) => m.StartComponent),
      },
      {
        path: "box-category",
        canActivate: [redesignRedirectGuard],
        loadComponent: () => import("./pages/box-category/box-category.component").then((m) => m.CategoryComponent),
      },
      {
        path: "box-style",
        children: [
          {
            path: ":category/:uploadDesign",
            canActivate: [redesignRedirectGuard],
            loadComponent: () => import("./pages/box-style/box-style.component").then((m) => m.BoxStyleComponent),
            data: {
              title: "Box Style",
            },
          },
          {
            path: ":category",
            canActivate: [redesignRedirectGuard],
            loadComponent: () => import("./pages/box-style/box-style.component").then((m) => m.BoxStyleComponent),
            data: {
              title: "Box Style",
            },
          },
        ],
      },
      {
        path: "box-options",
        children: [
          {
            path: ":category/:subcategory",
            canActivate: [redesignRedirectGuard],
            loadComponent: () => import("./pages/box-options/box-options.component").then((m) => m.BoxOptionsComponent),
            data: {
              title: "Box Options",
            },
          },
          {
            path: ":category/:subcategory/:uploadDesign",
            canActivate: [redesignRedirectGuard],
            loadComponent: () => import("./pages/box-options/box-options.component").then((m) => m.BoxOptionsComponent),
            data: {
              title: "Box Options",
            },
          },
        ],
      },
      {
        path: "samples",
        canActivate: [redesignRedirectGuard],
        loadComponent: () => import("./pages/samples/samples.component").then((m) => m.SamplesComponent),
      },
      {
        path: "upload-design",
        children: [
          {
            path: "",
            canActivate: [redesignRedirectGuard],
            loadComponent: () =>
              import("./pages/upload-design/upload-design.component").then((m) => m.UploadDesignComponent),
            data: {
              title: "Upload Design",
            },
          },
          {
            path: ":category/:subcategory",
            canActivate: [redesignRedirectGuard],
            loadComponent: () =>
              import("./pages/upload-design/upload-design.component").then((m) => m.UploadDesignComponent),
            data: {
              title: "Upload Design",
            },
          },
        ],
      },
      {
        path: "design",
        children: [
          {
            path: ":category/:subcategory",
            loadComponent: () => import("./pages/design/design.component").then((m) => m.DesignComponent),
            data: {
              title: "Design Your Box",
            },
          },
          {
            path: "",
            loadComponent: () => import("./pages/design/design.component").then((m) => m.DesignComponent),
            data: {
              title: "Design Your Box",
            },
          },
        ],
      },
      {
        path: "design-3d",
        loadChildren: () => import("./pages/design-3d.routes").then((m) => m.DESIGN_3D_ROUTES),
      },
      {
        path: "cart",
        canActivate: [redesignRedirectGuard],
        loadChildren: () => import("./pages/cart/cart.routes").then((m) => m.CART_ROUTES),
      },
      {
        path: "cart/takeout-1",
        loadChildren: () => import("./pages/cart/cart.routes").then((m) => m.CART_ROUTES),
      },
      {
        path: "cart/takeout-2",
        loadChildren: () => import("./pages/cart/cart.routes").then((m) => m.CART_ROUTES),
      },
      {
        path: "contact-us",
        loadComponent: () => import("./pages/contact-us/contact-us.component").then((m) => m.ContactUsComponent),
      },
      {
        path: "continue-project",
        canActivate: [requireCustomerLogin, redesignRedirectGuard],
        loadComponent: () =>
          import("./pages/continue-project/continue-project.component").then((m) => m.ContinueProjectComponent),
      },
      {
        path: "review-box",
        canActivate: [redesignRedirectGuard],
        loadComponent: () => import("./pages/review-box/review-box.component").then((m) => m.ReviewBoxComponent),
        data: {
          title: "Review & Add to Cart",
        },
      },
      {
        path: "designer",
        loadComponent: () => import("./features/remote/designer.component").then((m) => m.DesignerComponent),
      },
      {
        path: "designer/:target/:projectId",
        loadComponent: () => import("./features/remote/designer.component").then((m) => m.DesignerComponent),
      },
      {
        path: "account",
        canActivate: [requireCustomerLogin],
        children: [
          {
            path: "",
            canActivate: [redesignRedirectGuard],
            loadComponent: () => import("./pages/account/account.component").then((m) => m.AccountComponent),
            data: {
              title: "Account Page",
            },
          },
          {
            path: "update-account",
            canActivate: [redesignRedirectGuard],
            loadComponent: () =>
              import("./pages/account/update-account/update-account.component").then((m) => m.UpdateAccountComponent),
            data: {
              title: "Update Account",
            },
          },
          {
            path: "update-password",
            canActivate: [redesignRedirectGuard],
            loadComponent: () =>
              import("./pages/account/update-password/update-password.component").then(
                (m) => m.UpdatePasswordComponent
              ),
            data: {
              title: "Update Password",
            },
          },
        ],
      },
      ...(environment.features?.rewards
        ? [
            {
              path: "rewards",
              canActivate: [requireCustomerLogin],
              loadComponent: () => import("./pages/rewards/rewards.component").then((m) => m.RewardsComponent),
            },
          ]
        : []),
      {
        path: "order-history",
        canActivate: [requireCustomerLogin, redesignRedirectGuard],
        loadComponent: () =>
          import("./pages/account/order-history/order-history.component").then((m) => m.OrderHistoryComponent),
        data: {
          title: "Order History",
        },
      },
      {
        path: "design-services",
        loadComponent: () =>
          import("./pages/design-services/design-services.component").then((m) => m.DesignServicesComponent),
      },
      {
        path: "account/login",
        loadComponent: () => import("./pages/logpage/logpage.component").then((m) => m.LogPageComponent),
      },
      {
        path: "account/register",
        loadComponent: () => import("./pages/signup/signup.component").then((m) => m.SignupComponent),
      },
    ],
  },
  // Redesigned parallel pages - deliberately NOT nested under CommonLayoutComponent
  // (path: "" above), so they render app-redesign-shell instead of today's
  // header/footer. Reached only via redesignRedirectGuard above, or directly by
  // URL - see RedesignVariantService for how a visitor opts in (a `?design=redesign`
  // link, never randomized; no effect on anyone who doesn't have it).
  {
    path: "login-redesign",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages-redesign/login-redesign/login-redesign.component").then((m) => m.LoginRedesignComponent),
        data: { title: "Login" },
      },
      {
        path: "checkout/:checkoutId",
        loadComponent: () =>
          import("./pages-redesign/login-redesign/login-redesign.component").then((m) => m.LoginRedesignComponent),
        data: { title: "Login" },
      },
    ],
  },
  {
    path: "start-redesign",
    loadComponent: () =>
      import("./pages-redesign/start-redesign/start-redesign.component").then((m) => m.StartRedesignComponent),
  },
  {
    path: "box-category-redesign",
    loadComponent: () =>
      import("./pages-redesign/box-category-redesign/box-category-redesign.component").then(
        (m) => m.CategoryRedesignComponent
      ),
  },
  {
    path: "box-style-redesign",
    children: [
      {
        path: ":category/:uploadDesign",
        loadComponent: () =>
          import("./pages-redesign/box-style-redesign/box-style-redesign.component").then(
            (m) => m.BoxStyleRedesignComponent
          ),
        data: { title: "Box Style" },
      },
      {
        path: ":category",
        loadComponent: () =>
          import("./pages-redesign/box-style-redesign/box-style-redesign.component").then(
            (m) => m.BoxStyleRedesignComponent
          ),
        data: { title: "Box Style" },
      },
    ],
  },
  {
    path: "box-options-redesign",
    children: [
      {
        path: ":category/:subcategory",
        loadComponent: () =>
          import("./pages-redesign/box-options-redesign/box-options-redesign.component").then(
            (m) => m.BoxOptionsRedesignComponent
          ),
        data: { title: "Box Options" },
      },
      {
        path: ":category/:subcategory/:uploadDesign",
        loadComponent: () =>
          import("./pages-redesign/box-options-redesign/box-options-redesign.component").then(
            (m) => m.BoxOptionsRedesignComponent
          ),
        data: { title: "Box Options" },
      },
    ],
  },
  {
    path: "review-box-redesign",
    loadComponent: () =>
      import("./pages-redesign/review-box-redesign/review-box-redesign.component").then(
        (m) => m.ReviewBoxRedesignComponent
      ),
    data: { title: "Review & Add to Cart" },
  },
  {
    path: "upload-design-redesign",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages-redesign/upload-design-redesign/upload-design-redesign.component").then(
            (m) => m.UploadDesignRedesignComponent
          ),
        data: { title: "Upload Design" },
      },
      {
        path: ":category/:subcategory",
        loadComponent: () =>
          import("./pages-redesign/upload-design-redesign/upload-design-redesign.component").then(
            (m) => m.UploadDesignRedesignComponent
          ),
        data: { title: "Upload Design" },
      },
    ],
  },
  {
    path: "account-redesign",
    canActivate: [requireCustomerLogin],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages-redesign/account/account-redesign.component").then((m) => m.AccountRedesignComponent),
        data: { title: "Account Page" },
      },
      {
        path: "update-account",
        loadComponent: () =>
          import("./pages-redesign/account/update-account-redesign.component").then(
            (m) => m.UpdateAccountRedesignComponent
          ),
        data: { title: "Update Account" },
      },
      {
        path: "update-password",
        loadComponent: () =>
          import("./pages-redesign/account/update-password-redesign.component").then(
            (m) => m.UpdatePasswordRedesignComponent
          ),
        data: { title: "Update Password" },
      },
    ],
  },
  {
    path: "online-designs-redesign",
    canActivate: [requireCustomerLogin],
    loadComponent: () =>
      import("./pages-redesign/account/continue-project-redesign.component").then(
        (m) => m.ContinueProjectRedesignComponent
      ),
    data: { title: "Online Designs" },
  },
  {
    path: "offline-designs-redesign",
    canActivate: [requireCustomerLogin],
    loadComponent: () =>
      import("./pages-redesign/account/offline-designs-redesign.component").then(
        (m) => m.OfflineDesignsRedesignComponent
      ),
    data: { title: "Offline Designs" },
  },
  // Old bookmarks of the pre-rename path.
  { path: "continue-project-redesign", redirectTo: "online-designs-redesign", pathMatch: "full" },
  {
    path: "samples-redesign",
    loadComponent: () =>
      import("./pages-redesign/samples-redesign/samples-redesign.component").then((m) => m.SamplesRedesignComponent),
    data: { title: "Order Samples" },
  },
  {
    path: "cart-redesign",
    loadComponent: () => import("./pages-redesign/cart-redesign/cart-redesign.component").then((m) => m.CartRedesignComponent),
    data: { title: "Cart" },
  },
  {
    path: "order-history-redesign",
    canActivate: [requireCustomerLogin],
    loadComponent: () =>
      import("./pages-redesign/account/order-history-redesign.component").then((m) => m.OrderHistoryRedesignComponent),
    data: { title: "Order History" },
  },
  {
    path: "design-3d-redesign",
    children: [
      {
        path: ":category/:subcategory",
        loadComponent: () =>
          import("./pages-redesign/design-3d-redesign/design-3d-redesign.component").then(
            (m) => m.Design3dRedesignComponent
          ),
        data: { title: "Design Your Box" },
      },
    ],
  },
];
